// extracted by mini-css-extract-plugin
export default {"container":"SideMenuButton_container__+eXgO","iframe":"SideMenuButton_iframe__RALJi","menuAnimationIn":"SideMenuButton_menuAnimationIn__faY+Y","logo":"SideMenuButton_logo__2P3KC"};